import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_016.jpg';
page.paint = [
  {
    id: 'page008_game4',
    icon: 'ikona_cw4',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Skopiuj rysunek domku i wklej go do pustej ramki.',
      audio: 'files/page008/z8c4.mp3',
      item: {
        path: 'informatyka/files/page008/z.8cw.4.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page008_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Zaznacz obrazki zabawek.  ',
      audio: 'files/page008/z8c2.mp3',
      item: {
        path: 'informatyka/files/page008/z.8cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page008_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Skopiuj obrazek pajacyka i wklej go do pustej ramki.  ',
      audio: 'files/page008/z8c3.mp3',
      item: {
        path: 'informatyka/files/page008/z.8cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  {
    id: 'page008_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page016_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1713,
    },
    item: {
      id: 'page016_game10',
    },
    rectangle: {
      id: 'page016_rect0',
    },
  },
];
page.images = [
  {
    imageId: 'page016_zoom0',
    rectangle: {
      x: 612,
      y: 1726,
      width: 1176,
      height: 740,
    },
    imageSrc: 'images/page016/016 1.jpg',
  },
  {
    imageId: 'page016_zoom1',
    rectangle: {
      x: 137,
      y: 378,
      width: 809,
      height: 772,
    },
    imageSrc: 'images/page016/016 2.jpg',
  },
];
page.rectangle = [
  {
    id: 'page016_rect0',

    tooltip: '',

    linked: ['page016_game10'],
    x: 120,
    y: 1713,
    width: 477,
    height: 780,
  },
];
export default page;
